import { Link } from 'react-router-dom';
import { musician } from '@/mocks/musician';

export default function Footer() {
  return (
    <footer className="bg-primary-900 text-background-50">
      <div className="section-container py-14 md:py-18">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-12">
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-9 h-9 rounded-lg bg-white flex items-center justify-center overflow-hidden">
                <img
                  src={musician.logoUrl}
                  alt="Jackson Lacefield Logo"
                  className="w-7 h-7 object-contain"
                />
              </div>
              <span className="font-heading text-xl font-semibold text-white">
                Jackson Lacefield
              </span>
            </div>
            <p className="font-body text-sm text-white/90 leading-relaxed mb-5">
              Christian musician, tenor, and worship leader. Serving the Lord through music across Texas and beyond.
            </p>
            <div className="flex items-center gap-3">
              <a
                href={musician.youtubeChannelUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-white hover:bg-accent-500 hover:text-white transition-all duration-500 cursor-pointer"
                aria-label="YouTube"
              >
                <i className="ri-youtube-line text-lg"></i>
              </a>
              <a
                href={musician.instagramUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-white hover:bg-accent-500 hover:text-white transition-all duration-500 cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-lg"></i>
              </a>
              <a
                href={`mailto:${musician.email}`}
                className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-white hover:bg-accent-500 hover:text-white transition-all duration-500 cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a
                href={`tel:${musician.phone}`}
                className="w-9 h-9 rounded-full bg-white/15 flex items-center justify-center text-white hover:bg-accent-500 hover:text-white transition-all duration-500 cursor-pointer"
                aria-label="Phone"
              >
                <i className="ri-phone-line text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="font-label text-xs tracking-widest uppercase text-white/60 mb-4">
              Navigation
            </h3>
            <nav className="flex flex-col gap-2.5">
              <Link to="/" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">Home</Link>
              <Link to="/about" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">About</Link>
              <Link to="/music" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">Media</Link>
              <Link to="/gallery" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">Gallery</Link>
              <Link to="/experience" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">Experience</Link>
              <Link to="/contact" className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer whitespace-nowrap">Contact</Link>
            </nav>
          </div>

          <div>
            <h3 className="font-label text-xs tracking-widest uppercase text-white/60 mb-4">
              Contact
            </h3>
            <p className="font-body text-sm text-white/85 mb-3">{musician.location}</p>
            <a
              href={`mailto:${musician.email}`}
              className="font-body text-sm text-white hover:text-accent-300 transition-colors duration-500 cursor-pointer break-all block mb-2"
            >
              {musician.email}
            </a>
            <a
              href={`tel:${musician.phone}`}
              className="font-body text-sm text-white/85 hover:text-white transition-colors duration-500 cursor-pointer block"
            >
              {musician.phone}
            </a>
          </div>
        </div>

        <div className="mt-12 md:mt-16 pt-6 border-t border-white/10 flex flex-col items-center gap-2">
          <p className="font-label text-xs text-white/70">
            &copy; {new Date().getFullYear()} Jackson Lacefield. All rights reserved.
          </p>
          <a
            href="https://www.clarkwebdesign.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-label text-xs text-white/60 hover:text-white transition-colors duration-500 cursor-pointer"
          >
            Designed by ClarkWebDesign
          </a>
        </div>
      </div>
    </footer>
  );
}